import React from "react";
import { CircularProgress } from "@mui/material";
import TopBannerMessagePageTable from "./TopBannerMessagePageTable";
import { Query } from "react-apollo";
import { LIST_NOTIFICATION_BANNER_FOR_ADMIN } from "../../../gql/landingapi/queries";
import { OwcButton, OwcTypography } from "@one/react";
import { Module } from "../../../constants";
import { generateID } from "@digitallab/grid-common-components";

const { topBannerMessagePageAdmin } = Module.PAGE.ADMIN;

export const topBannerMessageAddd = React.createContext(<TopBannerMessagePageTable showTextOnly={true} />);
const TopBannerMessagePageAdmin = () => (
  <Query
    query={LIST_NOTIFICATION_BANNER_FOR_ADMIN}
    variables={{}}
    fetchPolicy="cache-and-network"
    id={generateID.UUID(topBannerMessagePageAdmin, `admin`, "query")}
  >
    {({ loading, error, refetch, data }) => {
      if (loading) {
        return (
          <div className="info" data-testid="loading">
            <CircularProgress size={40} />
          </div>
        );
      }
      if (error) {
        return (
          <div className="info" data-testid="error" id={generateID.UUID(topBannerMessagePageAdmin, `admin`, "div_error")}>
            <OwcTypography id={generateID.UUID(topBannerMessagePageAdmin, `admin`, "div_type")} variant="subtitle1" gutterBottom>
              {error.message}
            </OwcTypography>
            <OwcButton
              variant="primary"
              onClick={refetch}
              color="secondary"
              // startIcon={<ErrorIcon />}
              data-testid="try-again-button"
              id={generateID.UUID(topBannerMessagePageAdmin, `admin`, "div_try")}
            >
              Try again
            </OwcButton>
          </div>
        );
      }
      return <TopBannerMessagePageTable data={data?.listNotificationBanners?.items} refetch={refetch} />;
    }}
  </Query>
);

export default TopBannerMessagePageAdmin;
